// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_ORGANISATEURS = "GET_ORGANISATEURS";

// Add ORGANISATEUR
export const ADD_NEW_ORGANISATEUR = "ADD_NEW_ORGANISATEUR";
export const ADD_ORGANISATEUR_SUCCESS = "ADD_ORGANISATEUR_SUCCESS";
export const ADD_ORGANISATEUR_FAIL = "ADD_ORGANISATEUR_FAIL";

// Edit ORGANISATEUR
export const UPDATE_ORGANISATEUR = "UPDATE_ORGANISATEUR";
export const UPDATE_ORGANISATEUR_SUCCESS = "UPDATE_ORGANISATEUR_SUCCESS";
export const UPDATE_ORGANISATEUR_FAIL = "UPDATE_ORGANISATEUR_FAIL";
